import { StringKeyDictionary } from "../../commonInterfaces.js";
import { Helper } from "../util/helper.js";
import { Button } from "./button.js";
import React from "react";

export class ContextMenu extends React.Component<ContextMenuProps, any> {

    private body: JSX.Element;
    private id: string;
    private dict: StringKeyDictionary<() => void>;
    private contextMenuRef: kendo.ui.ContextMenu;
    private needRemove: boolean = false;

    constructor(props) {
        super(props)
        this.dict = {};
        this.initApp();

    }

    private initApp = () => {
        this.id = kendo.guid();
       
        this.body = this.createItems(this.props.items, true);
    }

    rebuildItems = (items: ContextMenuItem[]) => {
        this.dict = {};
        this.body = this.createItems(items, true);
        this.setState({}, this.buildContextMenu);
    }

    private createItems = (items: ContextMenuItem[], firstLevel: boolean = false) => {
        const iconsAreUsed = items.filter(f => !Helper.isNullOrEmpty(f.iconName)).length > 0;
        let listItems: JSX.Element[] = items.map((item: ContextMenuItem) => {
            if ((Helper.hasValue(item.hidden) && item.hidden === true)) {
            }
            else {
                const id = kendo.guid();
                if (Helper.hasValue(item.splitter) && item.splitter) {
                    return (
                        <React.Fragment key={id}>
                            <li className="k-separator"></li>
                        </React.Fragment>
                    );
                } else {
                    const icon = Helper.isNullOrEmpty(item.iconName)
                        ? <></>
                        : <i className={`fal fa-${item.iconName}`}></i>
                    const subList = Helper.hasValue(item.items) && item.items.length > 0
                        ? this.createItems(item.items)
                        : <></>
                    if (Helper.hasValue(item.onClick))
                        this.dict[id] = item.onClick;
                    return (
                        <React.Fragment key={id}>
                            <li id={id}>
                                {icon}
                                <label style={iconsAreUsed && Helper.isNullOrEmpty(item.iconName)
                                    ? { marginLeft: "24px" }
                                    : {}}>
                                    {item.title}
                                </label>
                                {subList}
                            </li>
                        </React.Fragment>
                    );
                }
            }
        });
        return (
            <ul id={firstLevel ? this.id : ''} className={firstLevel ? 'is-contextMenu' : ''}>
                {listItems}
            </ul>
        );
    }

    private buildContextMenu = () => {
        const options: kendo.ui.ContextMenuOptions = {
            target: "#" + this.props.target,
            showOn: this.props.showOn,
            select: (e) => {
                const func = this.dict[e.item.id];
                if (Helper.hasValue(func))
                    func();
            }
        };

        this.contextMenuRef = $("#" + this.id)
            .kendoContextMenu(options)
            .data("kendoContextMenu");

        this.afterKendoBuild();
    }

    //Dirty 
    //I suck at CSS
    //CSS = Can't style shit
    //FML
    private afterKendoBuild = () => {
        document.querySelectorAll('.is-contextMenu .k-link.k-menu-link').forEach((span: HTMLElement) => {
            span.style.padding = '.28em 1.8em .38em .9em'
        })
        document.querySelectorAll('.k-separator').forEach((element: HTMLElement) => {
            element.style.backgroundColor = "#666666"
        })


        this.cleanUpListener();

        const dps = document.getElementById("dps");
        if (dps) {
            dps.addEventListener("click", this.closeKendo);
            this.needRemove = true;
        }
    }

    private cleanUpListener = () => {
        const dps = document.getElementById("dps");
        if (dps && this.needRemove) {
            this.needRemove = false;
            dps.removeEventListener("click", this.closeKendo);
        }
    }

    private closeKendo = () => {
        this.contextMenuRef.close(this.contextMenuRef.element);
    }

    componentWillUnmount() {
        this.cleanUpListener();
        this.contextMenuRef.destroy()
    }

    componentDidMount() {
        this.buildContextMenu();
    }

    componentDidUpdate(prevProps, prevState) {
        if (JSON.stringify(this.props.items) != JSON.stringify(prevProps.items)) {
            this.rebuildItems(this.props.items);
        }
    }

    render() {
        return this.body;
    }
}

interface ContextMenuProps {
    target: string;
    items: ContextMenuItem[];
    showOn?: string;
    onUpdateItems?: (e: any) => void;
}

export interface ContextMenuItem {
    title: string;
    iconName?: string;
    onClick?: () => void;
    items?: ContextMenuItem[];
    splitter?: boolean;
    hidden?: boolean;
}

export class ContextMenuButton extends React.Component<ContextMenuButtonProps, any>{
    private id: string = kendo.guid();
    private contextMenuRef: ContextMenu = null;


    private renderButton = () => {
        return (
            <>
                <Button
                    handleClick={() => { }}
                    buttonStyle={this.props.buttonStyle}
                    iconName={this.props.iconName}
                    iconStyle={this.props.iconStyle}
                    id={this.id}
                />
            </>
        );
    }

    private renderContextMenu = () => {
        return (
            <>
                <ContextMenu
                    ref={(ref) => { this.contextMenuRef = ref }}
                    items={this.props.items}
                    target={this.id}
                    showOn={this.props.showOn}
                />
            </>
        );
    }

    render() {
        if (!Helper.hasValue(this.props.items) || this.props.items.length == 0)
            return null;
        return (
            <>
                {this.renderButton()}
                {this.renderContextMenu()}
            </>
        );
    }
}

export interface ContextMenuButtonProps {
    buttonStyle?: React.CSSProperties;
    iconName: string;
    iconStyle?: React.CSSProperties;
    items: ContextMenuItem[];
    showOn?: string;
}